import VideoJsPlayer from 'video.js/dist/types/player';
import { rewindController } from './rewindController';
import { RewindStitcherOptions } from './rewindStitcher.types';

/**
 * A video.js plugin.
 *
 * In the plugin function, the value of `this` is a video.js `Player`
 * instance. You cannot rely on the player being in a "ready" state here,
 * depending on how the plugin is invoked. This may or may not be important
 * to you; if not, remove the wait for "ready"!
 *
 * NOTES: it looks weird declaring 'this' but typescript needs you to do this to infer the types
 * see https://www.typescriptlang.org/docs/handbook/2/functions.html#declaring-this-in-a-function
 *
 * @function stitcher
 * @param    {Object} [options={}]
 *           An object of options left to the plugin author to define.
 */
export function rewindStitcher(this: VideoJsPlayer, options: RewindStitcherOptions) {
  rewindController(this, options);
}

export default rewindStitcher;
